import * as React from 'react';
import * as styleSheet from '../styles';
import { Box, Text } from '@enaep-ng/benchmark';
import { VersionType } from '../types';

const versionColorIndex = (currentVersion: any) => {
  return currentVersion.replace(/\.|MS|-/g, '') % 16;
};

export default function Version(props: VersionType) {
  return (
    <Box
      style={{
        backgroundColor: props.versionColors && props.versionColors[versionColorIndex(props.version)],
        borderColor:
          props.versionBorderColors && props.versionBorderColors[versionColorIndex(props.version)],
      }}
      sx={styleSheet.versionContainer}
    >
      <Text sx={styleSheet.versionTitle}>{props.title}</Text>
      <Text sx={styleSheet.vesionTag}>{props.version}</Text>
    </Box>
  );
}

export function VersionV2(props: VersionType) {
  return (
    <Box
      sx={styleSheet.versionContainerV2}
    >
      <Text sx={styleSheet.versionTitleV2}>{props.title.toUpperCase()}</Text>
      <Text sx={styleSheet.vesionTagV2}>{props.version}</Text>
    </Box>
  );
}
